export const generateFilename = (timestamp: number, sequence: number): string => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const seq = String(sequence).padStart(3, "0");

  return `photo_${year}${month}${day}_${hours}${minutes}${seconds}_${seq}.jpg`;
};

export const extractDate = (filename: string): string => {
  const match = filename.match(/photo_(\d{4})(\d{2})(\d{2})_/);
  if (!match) throw new Error("Invalid filename format");
  return `${match[1]}-${match[2]}-${match[3]}`;
};

export const isValidFilename = (filename: string): boolean => {
  return /^photo_\d{8}_\d{6}_\d{3}\.jpg$/.test(filename);
};
